import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'simplifieddialog',
  templateUrl: './simplifieddialog.component.html',
  styleUrls: ['./simplifieddialog.component.scss']
})
export class SimplifieddialogComponent implements OnInit {
  fileName: any;

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<SimplifieddialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public sanitizer: DomSanitizer) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    let fileUrl = "../../../../../assets/asset-import-files/" + this.dialogData.file;
    this.fileName = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
  }

  onNoClick(): void {
    this.dialogRef.close(true);
  }
}
